import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import QuizIntro from './components/QuizIntro';
import Quiz from './components/Quiz';
import Results from './components/Results';
import './App.css';

function App() {
  const [quizData, setQuizData] = useState({
    answers: [],
    score: 0,
    stage: '',
    completedAt: null
  });

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-indigo-50">
        <Routes>
          <Route path="/" element={<QuizIntro />} />
          <Route path="/quiz" element={<Quiz quizData={quizData} setQuizData={setQuizData} />} />
          <Route path="/results" element={<Results quizData={quizData} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;